export default "__VITE_ASSET__BDPNRx4S__"